import { SvgIcon, type SvgIconProps } from "@mui/material";
import { type SvgIconComponent } from "@mui/icons-material";

/**
 * R.E.REPO のマーク（左の図案）だけの版。rerepo_logo.svg のマーク部分と同じ path と色を使う。
 * path に fill を指定しているため、sx の color を渡しても色は変わらない。
 * サイドバーの折りたたみ時のアイコンに使い、文字入りのロゴを縮めて押し込まない。
 */
const RerepoMark: React.FC<SvgIconProps> = (props) => (
  <SvgIcon viewBox="443.5 504.2 39.6 39.6" {...props}>
    <path
      fill="rgb(80.392456%, 82.35321%, 81.568909%)"
      d="M 472.136719 518.183594 L 474.238281 517.5 C 475.675781 524.808594 477.128906 532.953125 477.976562 539.789062 L 473.449219 541.261719 C 473.4375 534.777344 472.835938 526.101562 472.136719 518.183594"
    />
    <path
      fill="rgb(15.686035%, 44.313049%, 49.803162%)"
      d="M 474.355469 517.460938 L 476.519531 516.757812 C 478.839844 523.984375 481.164062 531.664062 482.84375 538.207031 L 478.945312 539.472656 C 477.835938 533.039062 476.113281 525.058594 474.355469 517.460938"
    />
    <path
      fill="rgb(52.157593%, 74.510193%, 69.020081%)"
      d="M 469.742188 518.964844 L 472.054688 518.210938 C 472.496094 525.863281 472.800781 534.824219 472.402344 541.601562 L 465.851562 543.734375 C 467.675781 538.710938 468.9375 528.15625 469.742188 518.964844"
    />
    <path
      fill="rgb(80.392456%, 82.35321%, 81.568909%)"
      d="M 451.414062 523.769531 L 449.769531 522.292969 C 455.382812 517.390625 461.710938 512.0625 467.203125 507.910156 L 470.742188 511.09375 C 465.136719 514.347656 457.921875 519.207031 451.414062 523.769531"
    />
    <path
      fill="rgb(52.157593%, 74.510193%, 69.020081%)"
      d="M 449.679688 522.207031 L 447.988281 520.6875 C 453.085938 515.066406 458.574219 509.210938 463.402344 504.488281 L 466.445312 507.226562 C 461.429688 511.40625 455.378906 516.886719 449.679688 522.207031"
    />
    <path
      fill="rgb(15.686035%, 44.313049%, 49.803162%)"
      d="M 453.285156 525.453125 L 451.476562 523.828125 C 457.886719 519.617188 465.492188 514.871094 471.5625 511.828125 L 476.683594 516.441406 C 471.421875 517.371094 461.648438 521.550781 453.285156 525.453125"
    />
    <path
      fill="rgb(80.392456%, 82.35321%, 81.568909%)"
      d="M 466.589844 538.964844 L 466.128906 541.128906 C 459.082031 538.71875 451.300781 535.902344 444.957031 533.222656 L 445.945312 528.5625 C 451.566406 531.792969 459.382812 535.609375 466.589844 538.964844"
    />
    <path
      fill="rgb(15.686035%, 44.313049%, 49.803162%)"
      d="M 466.105469 541.246094 L 465.632812 543.472656 C 458.214844 541.871094 450.398438 540.042969 443.894531 538.226562 L 444.746094 534.21875 C 450.871094 536.472656 458.648438 538.972656 466.105469 541.246094"
    />
    <path
      fill="rgb(52.157593%, 74.510193%, 69.020081%)"
      d="M 467.113281 536.5 L 466.605469 538.882812 C 459.757812 535.4375 451.84375 531.21875 446.175781 527.488281 L 447.605469 520.746094 C 451.042969 524.835938 459.550781 531.210938 467.113281 536.5"
    />
  </SvgIcon>
);

/** MUI のアイコンと同じ型で渡せるようにする（サイドバーの icon）。 */
export const RerepoMarkIcon = Object.assign(RerepoMark, {
  muiName: "SvgIcon",
}) as unknown as SvgIconComponent;
